<template>
  <div id="system-manage-email-actions">
    <div class="ipub-h1 mar-b-20 line-h-40">
      Associated Email Template
    </div>
    <div>
      <site-search-group class="mar-b-16"
                         v-model="params.subject"
                         placeholder="Enter letter subject | Event name"
                         @search="getList()"
                         @clear="handleClear" />
      <div class="flex">
        <span class="line-h-40 ipub-p2 fw-bd">Letter Family</span>
        <ipub-select v-model="params.letterFamilyId"
                     placeholder="Select Journal"
                     class="mar-l-20"
                     style="width:400px"
                     @change="changeLetter">
          <ipub-select-option v-for="value in letterFamilyList"
                              :key="value.id"
                              :value="value.id">
            {{ value.name }}
          </ipub-select-option>
        </ipub-select>
      </div>
    </div>

    <div class="action-table mar-b-40">
      <ipub-table :columns="columns"
                  :pagination="pagination"
                  checkbox
                  checkKey="id"
                  ref="system-manage-email-actions-table"
                  @select="selectData"
                  :dataSource="dataSource">
        <template v-slot:letterFamily="{text}">
          {{text && text.name}}
        </template>
      </ipub-table>
    </div>
    <div class="ipub-p1 line-h-40">
      <ipub-button type="primary"
                   plain
                   :style="{ minWidth: '230px' }"
                   @click="back()">Back</ipub-button>
      <ipub-button type="primary"
                   :style="{ minWidth: '230px' }"
                   @click="associated">Associated Letter</ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
